import { ReactNode } from 'react'
import { useRouter } from 'next/router'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import CourseLayout from 'modules/course/components/course-layout'
import { CourseQuiz } from 'modules/course/course-quiz'
import { getCoursePageLayout } from 'modules/course/layouts/get-course-page-layout'
import { CourseQuizId } from 'modules/course/types/course-quiz-interface'
import { parseQueryId } from 'modules/course/utils/parse-query-id'

const QuizPage = (): ReactNode => {
  const router = useRouter()
  const { quizId: rawQuizId } = router.query
  const quizId = parseQueryId<CourseQuizId>(rawQuizId)

  return (
    <CourseLayout>
      <CourseQuiz quizId={quizId} />
    </CourseLayout>
  )
}

QuizPage.getLayout = getCoursePageLayout

export const getServerSideProps = withDomainAssets(baseServerSideProps)

export default QuizPage
